import debounce from 'lodash/debounce';

/* eslint-disable */
/* istanbul ignore next */
if (window.Element && !Element.prototype.closest) {
  Element.prototype.closest =
  function(s) {
      let matches = (this.document || this.ownerDocument).querySelectorAll(s),
          i,
          el = this;
      do {
          i = matches.length;
          while (--i >= 0 && matches.item(i) !== el) {};
      } while ((i < 0) && (el = el.parentElement));
      return el;
  };
}
/* eslint-enable */
class StickyFilters {
  constructor(el, binding) {
    this.binding = binding;
    this.element = el;
    this.lastKnownScrollPos = 0;
    this.ticking = false;

    this.props = {
      limitTop: 0,
      prevScrollPosition: 0,
      prevMenuTop: 0,
      windowHeight: window.innerHeight,
      scrollVerticalThreshold: 0,
      menuBottom: 0,
      disabled: true,
    };

    window.onload = () => {
      this.dom = {
        filterWrapper: this.element,
        filterWrapperParent: this.element.closest('.filter-content-wrapper'),
        filters: this.element.querySelector('.filters'),
        grid: document.querySelector('.grid-wrapper'),
        limit:
          document.querySelector('.two-zones-block') ||
          document.querySelector('.call-to-action-bar-wrapper') ||
          document.querySelector('footer'),
      };

      this.dom.filters.classList.add('is-stickable');

      this.setLimitTop();
      setTimeout(() => {
        this.adjustVerticalScrollThreshold();
      }, 200);
      this.bind();
    };
  }

  bind() {
    /* istanbul ignore next */
    window.addEventListener('scroll', this.onScroll.bind(this));
    window.addEventListener('resize', debounce(this.adjustVerticalScrollThreshold.bind(this), 50));

    if (window.eventBus) {
      /* istanbul ignore next */
      window.eventBus.$on(
        'filter::resize',
        debounce(this.adjustVerticalScrollThreshold.bind(this), 50),
      );
      window.eventBus.$on(
        'headerHeight.updated',
        debounce(this.adjustVerticalScrollThreshold.bind(this), 50),
      );
    }

    this.props.disabled = false;
  }

  onScroll() {
    this.lastKnownScrollPos = window.pageYOffset;
    /* istanbul ignore if */
    if (!this.ticking) {
      window.requestAnimationFrame(() => {
        this.adjustVerticalPos();
        this.ticking = false;
      });
    }
    this.ticking = true;
  }

  adjustVerticalScrollThreshold() {
    this.dom.filterWrapper.style.top = `${Math.ceil(this.dom.filterWrapperParent.getBoundingClientRect().top + window.pageYOffset)}px`;
    this.dom.filterWrapper.style.width = `${this.dom.filterWrapperParent.offsetWidth}px`;
    this.dom.filterWrapper.style.position = 'fixed';

    const height =
      this.dom.filters.offsetHeight +
      (parseInt(window.getComputedStyle(this.dom.filterWrapper).top, 10) || 0);
    this.props.windowHeight = window.innerHeight;
    this.props.scrollVerticalThreshold = Math.max(height - this.props.windowHeight, 0);

    this.props.menuBottom = this.dom.filterWrapper.offsetTop + this.outerHeight(this.dom.filters);
    this.dom.grid.style.minHeight = `${height}px`;
    this.adjustVerticalPos();
  }

  setLimitTop() {
    this.props.limitTop = this.dom.limit.offsetTop;
  }

  outerHeight(el) {
    let height = el.offsetHeight;
    const style = window.getComputedStyle(el);
    height += parseInt(style.marginTop, 10) || 0 + parseInt(style.marginBottom, 10) || 0;
    return height;
  }

  adjustVerticalPos() {
    /* istanbul ignore if */
    if (this.props.disabled) {
      return;
    }

    /* istanbul ignore next */
    const scrollTop = window.pageYOffset;
    const prevTop = this.props.prevMenuTop;

    let scrollDelta = scrollTop - this.props.prevScrollPosition;
    let limitTopMenuBottomSpace = 0;
    let top = 0;
    let o = false;

    this.setLimitTop();

    /* istanbul ignore next */
    limitTopMenuBottomSpace = this.props.limitTop - this.props.menuBottom;
    this.props.prevScrollPosition = scrollTop;

    /* istanbul ignore next */
    if (limitTopMenuBottomSpace < 0 && scrollTop < this.props.limitTop - this.props.windowHeight) {
      o = true;
      scrollDelta *= 1 + (limitTopMenuBottomSpace / this.props.scrollVerticalThreshold) * -1;
    }

    /* istanbul ignore next */
    if (prevTop - scrollDelta <= 0 && scrollTop > 0) {
      top = prevTop - scrollDelta;
    }

    /* istanbul ignore next */
    o ||
      (-1 * (prevTop - scrollDelta) > this.props.scrollVerticalThreshold &&
        ((top = -1 * this.props.scrollVerticalThreshold),
        this.props.limitTop && (top = Math.min(top, limitTopMenuBottomSpace - scrollTop)))); // NOSONAR

    this.dom.filters.style.transform = `translateY(${top}px)`;
    this.props.prevMenuTop = top;
  }

  unbind() {
    /* istanbul ignore next */
    window.removeEventListener('scroll', this.onScroll.bind(this));
    window.removeEventListener('resize', this.adjustVerticalScrollThreshold.bind(this));
    if (window.eventBus) {
      /* istanbul ignore next */
      window.eventBus.$off(
        'filter::resize',
        debounce(this.adjustVerticalScrollThreshold.bind(this), 50),
      );
      window.eventBus.$off(
        'headerHeight.updated',
        debounce(this.adjustVerticalScrollThreshold.bind(this), 50),
      );
    }
  }

  static install(Vue) {
    let stickyFilters;
    Vue.directive('sticky-filters', {
      bind: (el, binding) => {
        stickyFilters = new StickyFilters(el, binding);
      },
      unbind: (el) => stickyFilters.unbind(el),
    });
  }
}

export default {
  install: (Vue) => StickyFilters.install(Vue),
  Instance: StickyFilters,
};
